/* eslint-disable max-len */
import React from 'react';

interface Props {
  color?: string;
}

export default function AccountIcon({ color = '#047A9C' }: Props) {
  return (
    <path
      d="M9,14.3069995 L8.99995757,13.2901693 C8.99995757,13.1071243 8.93301329,12.930399 8.81173887,12.7932932 C7.27057962,11.0509491 6.5,8.8976291 6.5,6.33333333 C6.5,3.2666626 8.66666667,1 12,1 C15.3333333,1 17.5,3.2666626 17.5,6.33333333 C17.5,8.89765622 16.7294041,11.0509946 15.1882122,12.7933485 L15.1882279,12.7933624 C15.0669477,12.9304726 15,13.1072048 15,13.290257 L15,14.3069995 C15,14.7238441 15.2585728,15.0969648 15.6488766,15.2433287 L20.6591771,17.1221914 C22.0671982,17.6501993 23,18.9962328 23,20.5 L23,22 C23,22.5522847 22.5522847,23 22,23 L2,23 C1.44771525,23 1,22.5522847 1,22 L1,20.5 C1,18.9962328 1.9328018,17.6501993 3.34082294,17.1221914 L8.35112344,15.2433287 C8.74142717,15.0969648 9,14.7238441 9,14.3069995 Z"
      fill={color}
    />
  );
}
